import { type InputHTMLAttributes, type ReactNode, forwardRef } from "react";
import { cn } from "@/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, icon, ...props }, ref) => {
    if (icon) {
      return (
        <div className="relative">
          <span className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-muted">
            {icon}
          </span>
          <input
            ref={ref}
            className={cn(
              "w-full rounded-xl border border-border bg-surface py-2.5 pr-3.5 pl-10 text-sm text-foreground placeholder:text-muted outline-none transition-colors focus:border-primary focus:glow-sm",
              className,
            )}
            {...props}
          />
        </div>
      );
    }

    return (
      <input
        ref={ref}
        className={cn(
          "w-full rounded-xl border border-border bg-surface px-3.5 py-2.5 text-sm text-foreground placeholder:text-muted outline-none transition-colors focus:border-primary focus:glow-sm",
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";
